export enum WebhookEventType {
  PAYMENT_RECEIVED = 'payment_received',
  INVOICE_CREATED = 'invoice_created',
  INVOICE_SENT = 'invoice_sent',
  INVOICE_OVERDUE = 'invoice_overdue',
}

export enum WebhookStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface Webhook {
  id: string;
  url: string;
  clientId: string;
  client?: {
    id: string;
    name: string;
  };
  events: WebhookEventType[];
  secret?: string;
  status: WebhookStatus;
  metadata?: Record<string, any>;
  verifierToken?: string;
  quickbooksEnabled: boolean;
  quickbooksRealmId?: string;
  quickbooksOauthToken?: string;
  quickbooksWebhookId?: string;
  lastNotificationTime?: string;
  createdAt: string;
  updatedAt: string;
} 